import { gateway } from "../../../../gateway";

export type CreateJobWithoutQuotePayload = Record<string, any>;
export type CreateJobWithoutQuoteResponse<T = any> = T;

export const createJobWithoutQuoteAction = async (
  payload: CreateJobWithoutQuotePayload,
  token: string
) => {
  const res = await gateway.post<CreateJobWithoutQuoteResponse>(
    `/jobs/self`,
    payload,
    { headers: { Authorization: token } }
  );

  return res.data;
};
